import React from "react";
import { Form, Input } from "antd";

export default function DetailPointForm({ title }) {
  return (
    <>
      <h3>{title}</h3>
      <Form.Item name="point">
        <Input.Group compact>
          <Form.Item
            name={["point", "lattitude"]}
            label="Lattitude"
            style={{ display: "inline-block", width: "calc(50% - 4%)" }}
          >
            <Input></Input>
          </Form.Item>
          <Form.Item
            name={["point", "longtitude"]}
            label="Longtitude"
            style={{
              display: "inline-block",
              width: "calc(50% - 4%)",
              margin: "0 4%",
            }}
          >
            <Input></Input>
          </Form.Item>
        </Input.Group>
      </Form.Item>
      <Form.Item name="site" label="Site/Node/Cust">
        <Input></Input>
      </Form.Item>
      <Form.Item name="distance" label="ระยะทางจาก Site - จุดที่มีปัญหา(เมตร)">
        <Input></Input>
      </Form.Item>
      <Form.Item name="remark" label="หมายเหตุ">
        <Input.TextArea rows="5"></Input.TextArea>
      </Form.Item>
    </>
  );
}
